import { Field, Form, Formik } from "formik";
import moment from "moment";
import TimePicker from "rc-time-picker";
import ReactDatetime from "react-datetime";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import * as Yup from "yup";
import "rc-time-picker/assets/index.css";
import "react-datetime/css/react-datetime.css";
import { Calendar, Time } from "../../../common/imagePath";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import FileInput from "../../../components/FormControls/FileInput";
import { uploadAWS } from "../../../common/AWSHelper";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CUSTOMER,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";

const ManageEmployee = (props) => {
  // const token = localStorage.getItem("Token");
  // const Id = localStorage.getItem("ID");
  const [customFields, setCustomFields] = useState([]);
  const [customFieldEmployeeValues, setCustomFieldEmployeeValues] = useState(
    []
  );
  const [loading, setLoading] = useState(false);
  const [allowedToLoginStartTime, setAllowedToLoginStartTime] = useState(
    moment()
  );
  const [allowedToLoginEndTime, setAllowedToLoginEndTime] = useState(moment());
  const [
    commissionPercentCalculationMethod,
    setCommissionPercentCalculationMethod,
  ] = useState([]);
  const [
    selectedCommissionPercentCalculationMethod,
    setSelectedCommissionPercentCalculationMethod,
  ] = useState(0);
  const [hireDate, setHireDate] = useState(moment().format("MM-DD-YYYY"));
  const [birthday, setBirthday] = useState(moment().format("MM-DD-YYYY"));
  const [terminationDate, setTerminationDate] = useState(
    moment().format("MM-DD-YYYY")
  );
  const [managecustomerID, setManageCustomerID] = useState(1);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [location, setLocations] = useState([]);
  const [check, setCheck] = useState([]); // for loactions checkbox
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState(0);
  const [defaultRegister, setDefaultRegister] = useState([]);
  const [selectedDefaultRegister, setSelectedDefaultRegister] = useState([]);
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [File1Url, setFile1Url] = useState("");
  const [selectedFile1, setSelectedFile1] = useState("");
  const [File2Url, setFile2Url] = useState("");
  const [selectedFile2, setSelectedFile2] = useState("");
  const [File3Url, setFile3Url] = useState("");
  const [selectedFile3, setSelectedFile3] = useState("");
  const [File4Url, setFile4Url] = useState("");
  const [selectedFile4, setSelectedFile4] = useState("");
  const [File5Url, setFile5Url] = useState("");
  const [selectedFile5, setSelectedFile5] = useState("");
  const [selectInactive, setSelectInactive] = useState(false);
  let [selectedLocationItems, setSelectedLocationItems] = useState([]);

  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [customFieldsBinding, setCustomFieldsBinding] = useState([]);

  const [selectedCustomFile, setSelectedCustomFile] = useState("");
  const [customFileUrl, setCustomFileUrl] = useState("");
  const [eyeNew, seteyeNew] = useState(true);
  const [eyepasswordnew, seteyePasswordNew] = useState(true);

  const [formValues, setFormValues] = useState({
    FirstName: "",
    LastName: "",
    EMail: "",
    PhoneNumber: "",
    SelectImage: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    Comments: "",
    AllowedToLoginStartTime: "",
    AllowedToLoginEndTime: "",
    OverridePriceAdjustments: false,
    MaxDiscount: 0.0,
    CommissionDefaultRate: 0.0,
    CommissionPercentCalculationMethod: "",
    HireDate: "",
    Birthday: "",
    EmployeeNumber: 0,
    Language: "",
    DefaultRegister: "",
    // LocationName: [],
    Locations: "",
    FileId1: 0,
    File1: "",
    FileId2: 0,
    File2: "",
    FileId3: 0,
    File3: "",
    FileId4: 0,
    File4: "",
    FileId5: 0,
    File5: "",
    Username: "",
    Password: "",
    PasswordAgain: "",
    ForcePasswordChangeUponLogin: false,
    AlwaysRequirePasswordWhenSwitchingUser: false,
    DarkMode: false,
    Inactive: false,
    ReasonInactive: "",
    TerminationDate: "",
    IPAddressesEmployeeCanAccessFrom: "",
  });

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  let navigate = useNavigate();

  const paramObject = useParams();

  const validationSchema = Yup.object().shape({
    FirstName: Yup.string().required("First Name is required"),
    LastName: Yup.string().required("Last Name is required"),
    EMail: Yup.string().email().required("E-Mail is required"),
    PhoneNumber: Yup.number().required("Phone Number is required"),
    Address1: Yup.string().required("Address 1 is required"),
    Address2: Yup.string().required("Address 2 is required"),
    City: Yup.string().required("City is required"),
    StateProvince: Yup.string().required("State/Province is required"),
    Zip: Yup.number().required("Zip is required"),
    Country: Yup.string().required("Country is required"),
    MaxDiscount: Yup.number().notRequired(),
    CommissionDefaultRate: Yup.number().notRequired(),
    Username: Yup.string().required("Username is required"),
    EmployeeNumber: Yup.string().required("EmployeeNumber is required"),
    Password: Yup.string(),
    PasswordAgain: Yup.string().oneOf(
      [Yup.ref("Password"), null],
      "Passwords must match"
    ),
    // DefaultRegister: Yup.string().required("Location is required"),
  });

  const onChangeAllowedToLoginStartTime = (e) => {
    setAllowedToLoginStartTime(moment(e));
  };

  const onChangeAllowedToLoginEndTime = (e) => {
    setAllowedToLoginEndTime(moment(e));
  };

  const handleHireDate = (momentDate) => {
    setHireDate(moment(momentDate).format("MM-DD-YYYY"));
  };

  const handleBirthday = (momentDate) => {
    setBirthday(moment(momentDate).format("MM-DD-YYYY"));
  };

  const handleTerminationDate = (momentDate) => {
    setTerminationDate(moment(momentDate).format("MM-DD-YYYY"));
  };

  const handleSelectInactive = () => {
    setSelectInactive(!selectInactive);
  };

  //Setting the default date as a today's date
  const today = moment();
  // console.log(today.format("MM-DD-YYYY"), "today");

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
    }), // dropdown menu css
  };

  const handleCheck = (event) => {
    const updatedList = check;

    // console.log(event.target.value);
    if (event.target.checked) {
      updatedList.push(event.target.value);
    } else {
      updatedList.splice(check.indexOf(event.target.value), 1);
    }

    console.log(updatedList);
  };

  const handleSelectCustomCheckBox = () => {
    console.log("Checked");
    setSelectCustomCheckBox(!selectCustomCheckBox);
    console.log(selectCustomCheckBox);
  };

  // Return classes based on whether item is checked
  var isCheck = (item) =>
    check.includes(item.Id) ? "checked-item" : "not-checked-item";

  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);
    setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
      if (data) {
        if (type === "SelectImage") {
          setImageUrl(data);
          setLoading(false);
        } else if (type === "File1") {
          setFile1Url(data);
          setLoading(false);
        } else if (type === "File2") {
          setFile2Url(data);
          setLoading(false);
        } else if (type === "File3") {
          setFile3Url(data);
          setLoading(false);
        } else if (type === "File4") {
          setFile4Url(data);
          setLoading(false);
        } else if (type === "File5") {
          setFile5Url(data);
          setLoading(false);
        } else {
          customFieldEmployeeValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
          console.log("customFileUrl", customFileUrl);
          setLoading(false);
        }
      }
    });
  };

  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    if (fieldTypeName === "Dropdown") {
      customFieldEmployeeValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.value,
      };
    } else if (fieldTypeName === "CheckBox") {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked,
      };
    } else if (fieldName === "E-Mail") {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Website") {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "PhoneNumber") {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Date") {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else {
      customFieldEmployeeValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    }
  };

  const handleSubmit = (values) => {
    let fileValues = [
      {
        FilesId: values.FileId1,
        FileName: File1Url,
      },
      {
        FilesId: values.FileId2,
        FileName: File2Url,
      },
      {
        FilesId: values.FileId3,
        FileName: File3Url,
      },
      {
        FilesId: values.FileId4,
        FileName: File4Url,
      },
      {
        FilesId: values.FileId5,
        FileName: File5Url,
      },
    ];

    let filedata = fileValues.filter(function (rowData) {
      return rowData.FileName != "";
    });

    let customFielddata = customFieldEmployeeValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });

    let fileValuesData = {};
    let customValuesData = {};

    fileValuesData.employeeFilesXML = filedata;
    customValuesData.customValueXML = customFielddata;

    let filejsonstring = JSON.stringify(fileValuesData);
    let customvaluejsonstring = JSON.stringify(customValuesData);

    let employeeData = {
      xmlemployeefiles: filejsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      id: paramObject.id || 0,
      firstname: values.FirstName,
      lastname: values.LastName,
      email: values.EMail,
      phonenumber: values.PhoneNumber,
      selectimage: ImageUrl,
      address1: values.Address1,
      address2: values.Address2,
      city: values.City,
      state: values.StateProvince,
      zip: values.Zip,
      country: values.Country,
      comments: values.Comments,
      loginstarttime: allowedToLoginStartTime.format("HH:mm"),
      loginendtime: allowedToLoginEndTime.format("HH:mm"),
      overridepriceadjustments: values.OverridePriceAdjustments,
      maxdiscountpercent: values.MaxDiscount,
      commissiondefaultrate: values.CommissionDefaultRate,
      commissionpercenttype: selectedCommissionPercentCalculationMethod.value,
      hiredate: moment(hireDate).format("YYYY-MM-DD"), // hireDate,
      birthday: moment(birthday).format("YYYY-MM-DD"), //birthday,
      employeenumber: values.EmployeeNumber,
      language: selectedLanguages.value,
      locationid: selectedDefaultRegister.toString(),
      // locationname: check,
      username: values.Username,
      password: values.Password,
      forcepasswordchange: values.ForcePasswordChangeUponLogin,
      alwaysrequirepassword: values.AlwaysRequirePasswordWhenSwitchingUser,
      darkmode: values.DarkMode,
      inactive: values.Inactive,
      reasoninactive: values.ReasonInactive,
      terminationdate: moment(terminationDate).format("YYYY-MM-DD"), //terminationDate,
      allowedipaddress: values.IPAddressesEmployeeCanAccessFrom,
      loginuserid: Id,
    };

    console.log("employeeData: ", employeeData);

    setLoading(true);
    axios
      .post(`${config.employeesBaseUrl}/employees/upsert`, employeeData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/employees");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Email" + ALREADY_EXIST);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -3
        ) {
          toastError("Employee number" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Binding Customer Fields
    axios
      .get(
        `${config.employeesBaseUrl}/employees/employeescustomgetall?id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData.customefield);
      })
      .catch((err) => {
        console.log("Error: ", err);
        setLoading(false);
      });

    // for loactions checkbox
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        setLocations(res.data.ResponseData);
      })
      .catch((err) => {
        setLoading(false);
      });

    // languages dropdown
    axios
      .get(`${config.employeesBaseUrl}/employees/employeelanguagesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        res.data.ResponseData.map((language, index) => {
          languages[index] = { label: language.Name, value: language.Id };
        });
      })
      .catch((err) => {
        setLoading(false);
      });

    // default register dropdown
    axios
      .get(`${config.employeesBaseUrl}/employees/employeeregisterdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        res.data.ResponseData.map((defaultRegisterData, index) => {
          defaultRegister[index] = {
            label: defaultRegisterData.Name,
            value: defaultRegisterData.Id,
          };
        });
      })
      .catch((err) => {
        setLoading(false);
      });

    // Commission Percent Calculation Method dropdown
    axios
      .get(`${config.employeesBaseUrl}/employees/employeecommissiondropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        res.data.ResponseData.map(
          (commissionPercentCalculationMethodData, index) => {
            commissionPercentCalculationMethod[index] = {
              label: commissionPercentCalculationMethodData.Name,
              value: commissionPercentCalculationMethodData.Id,
            };
          }
        );
      })
      .catch((err) => {
        setLoading(false);
      });

    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.employeesBaseUrl}/employees/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res: " + res);

          const customFieldValueData = res.data.ResponseData.CustomFieldValues;
          console.log("customFieldValueData: ", customFieldValueData);

          const employeesData = res.data.ResponseData.EmployeeDetails[0];
          const fileData = res.data.ResponseData.FileDetails;

          console.log(employeesData);

          setSelectInactive(employeesData.Inactive === 1 ? true : false);
          setImageUrl(employeesData.Selectimage);
          setSelectedDefaultRegister(
            employeesData.Locations.split(",").map(Number)
          );

          // setAllowedToLoginStartTime(employeesData.Loginstarttime);
          // setAllowedToLoginEndTime(employeesData.Loginendtime);

          setHireDate(moment(employeesData.Hiredate).format("MM-DD-YYYY"));

          setBirthday(moment(employeesData.Birthday).format("MM-DD-YYYY"));
          setTerminationDate(
            moment(employeesData.Terminationdate).format("MM-DD-YYYY")
          );

          languages.map((selectlanguages) => {
            if (selectlanguages.value == employeesData.Language) {
              setSelectedLanguages(selectlanguages);
              console.log(selectedLanguages);
            }
          });

          defaultRegister.map((selectdefaultRegister) => {
            if (selectdefaultRegister.value == employeesData.Defaultregister) {
              setSelectedDefaultRegister(selectdefaultRegister);
              console.log(selectedDefaultRegister);
            }
          });

          commissionPercentCalculationMethod.map(
            (selectcommissionPercentCalculationMethod) => {
              if (
                selectcommissionPercentCalculationMethod.value ==
                employeesData.Commissionpercenttype
              ) {
                setSelectedCommissionPercentCalculationMethod(
                  selectcommissionPercentCalculationMethod
                );
                console.log(selectedCommissionPercentCalculationMethod);
              }
            }
          );

          const splitLocationValue = employeesData.Locations?.split(",");
          if (splitLocationValue !== undefined) {
            if (
              splitLocationValue[0] != "" &&
              splitLocationValue[0] != null &&
              splitLocationValue[0] != undefined
            ) {
              selectedLocationItems = splitLocationValue;
              setSelectedLocationItems(selectedLocationItems);
              console.log(selectedLocationItems);
            }
          }

          const data = {
            FirstName: employeesData.Firstname,
            LastName: employeesData.Lastname,
            EMail: employeesData.Email,
            PhoneNumber: employeesData.Phonenumber,
            SelectImage: employeesData.Selectimage,
            Address1: employeesData.Address1,
            Address2: employeesData.Address2,
            City: employeesData.City,
            StateProvince: employeesData.State,
            Zip: employeesData.Zip,
            Country: employeesData.Country,
            Comments: employeesData.Comments,
            AllowedToLoginStartTime: employeesData.Loginstarttime,
            AllowedToLoginEndTime: employeesData.Loginendtime,
            OverridePriceAdjustments:
              employeesData.Overridepriceadjustments === 1 ? true : false,
            MaxDiscount: employeesData.Maxdiscountpercent,
            CommissionDefaultRate: employeesData.Commissiondefaultrate,
            CommissionPercentCalculationMethod:
              employeesData.Commissionpercenttype,
            HireDate: moment(employeesData.Hiredate).format("MM-DD-YYYY"),
            Birthday: moment(employeesData.Birthday).format("MM-DD-YYYY"),
            EmployeeNumber: employeesData.Employeenumber,
            Language: employeesData.Language,
            DefaultRegister: employeesData.Defaultregister,
            Locations: employeesData.Locations,
            FileId1: fileData[0]?.Id,
            File1: "",
            FileId2: fileData[1]?.Id,
            File2: "",
            FileId3: fileData[2]?.Id,
            File3: "",
            FileId4: fileData[3]?.Id,
            File4: "",
            FileId5: fileData[4]?.Id,
            File5: "",
            Username: employeesData.Username,
            Password: "", // employeesData.Password,
            PasswordAgain: "", // employeesData.Password,
            ForcePasswordChangeUponLogin:
              employeesData.Forcepasswordchange === 1 ? true : false,
            AlwaysRequirePasswordWhenSwitchingUser:
              employeesData.Alwaysrequirepassword === 1 ? true : false,
            DarkMode: employeesData.Darkmode === 1 ? true : false,
            Inactive: employeesData.Inactive === 1 ? true : false,
            ReasonInactive: employeesData.Reasoninactive,
            TerminationDate: moment(employeesData.Terminationdate).format(
              "MM-DD-YYYY"
            ),
            IPAddressesEmployeeCanAccessFrom: employeesData.Allowedipaddress,
          };

          const newData = { ...data };

          for (let i = 0; i < customFieldValueData.length; i++) {
            newData[customFieldValueData[i].CustomFieldControlID] =
              customFieldValueData[i].Value === "false"
                ? false
                : customFieldValueData[i].Value === "true"
                ? true
                : customFieldValueData[i].Value;
          }

          setFormValues(newData);
          console.log("fromValues", formValues);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  console.log(selectedDefaultRegister, "selectedDefaultRegister123");

  const handleCustomer = (id) => {
    setManageCustomerID(id);
  };

  let locationdropdown = [];
  const data = location.map((item, index) => {
    locationdropdown[index] = { label: item.Name, value: item.Id };
  });

  const onEyeNewClick = () => {
    seteyeNew(!eyeNew);
  };

  const onEyePasswordNewClick = () => {
    seteyePasswordNew(!eyepasswordnew);
  };

  const handleDefaultRegister = (event) => {
    const val = event?.map((u) => u.value);
    formValues.DefaultRegister = val.toString();

    setSelectedDefaultRegister(event?.map((u) => u.value));
    // setCheck(event?.map((u)=>u.label))
  };

  console.log(formValues, "formValues");

  // console.log(selectedDefaultRegister.toString(), "pppp==>")
  // console.log(check,"check")

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Employee</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/employees">Employees List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Employee</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className={"col-lg-12 col-md-12"}>
              <div className="card bg-white">
                <div className="card-body">
                  <div className="email-header">
                    <div className="row">
                      <div className="col-lg-20 top-action-left col-sm-20">
                        <div className="float-left">
                          <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link active"
                                id="personal-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#home"
                                type="button"
                                role="tab"
                                aria-controls="home"
                                aria-selected="true"
                                onClick={() => handleCustomer(1)}
                              >
                                Personal Details
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link"
                                id="address-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#profile"
                                type="button"
                                role="tab"
                                aria-controls="profile"
                                aria-selected="false"
                                onClick={() => handleCustomer(2)}
                              >
                                Address
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link"
                                id="account-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#contact"
                                type="button"
                                role="tab"
                                aria-controls="contact"
                                aria-selected="false"
                                onClick={() => handleCustomer(3)}
                              >
                                Employee Login
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link"
                                id="tax-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#contact"
                                type="button"
                                role="tab"
                                aria-controls="contact"
                                aria-selected="false"
                                onClick={() => handleCustomer(4)}
                              >
                                Files
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link"
                                id="custom-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#contact"
                                type="button"
                                role="tab"
                                aria-controls="contact"
                                aria-selected="false"
                                onClick={() => handleCustomer(5)}
                              >
                                Other Fields
                              </button>
                            </li>
                          </ul>
                          <Formik
                            {...props}
                            initialValues={formValues}
                            validationSchema={validationSchema}
                            enableReinitialize
                            onSubmit={handleSubmit}
                          >
                            {({
                              errors,
                              touched,
                              handleChange,
                              validateForm,
                            }) => (
                              <>
                                <Form>
                                  <div className="card-body">
                                    {managecustomerID === 1 ? (
                                      <>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                First Name{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm  ${
                                                    errors.FirstName
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="FirstName"
                                                  name="FirstName"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.FirstName &&
                                                  errors.FirstName
                                                    ? errors.FirstName
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Last Name{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.LastName
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="LastName"
                                                  name="LastName"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.LastName &&
                                                  errors.LastName
                                                    ? errors.LastName
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                E-Mail{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.EMail
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="EMail"
                                                  name="EMail"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.EMail && errors.EMail
                                                    ? errors.EMail
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Phone Number{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.PhoneNumber
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="PhoneNumber"
                                                  name="PhoneNumber"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.PhoneNumber &&
                                                  errors.PhoneNumber
                                                    ? errors.PhoneNumber
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Select Image
                                              </label>
                                              <div className="col-md-9">
                                                <FileInput
                                                  id="SelectImage"
                                                  name="SelectImage"
                                                  className="form-control form-control-sm"
                                                  value={selectedImage}
                                                  accept="image/*"
                                                  handleChange={
                                                    _handleFileChange
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Employee Number{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm`}
                                                  onChange={handleChange}
                                                  id="EmployeeNumber"
                                                  name="EmployeeNumber"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Hire Date
                                              </label>
                                              <div className="col-lg-9">
                                                <div className="input-group">
                                                  {/* <span
                                                      className="input-group-text"
                                                      id="basic-addon1"
                                                    >
                                                      <img src={Calendar} alt="img" />
                                                    </span> */}
                                                  <div
                                                    style={{ width: "100%" }}
                                                  >
                                                    <input
                                                      type="date"
                                                      className="form-control form-control-sm"
                                                      // value={birthday}
                                                      onChange={handleChange}
                                                      id="HireDate"
                                                      name="HireDate"
                                                      defaultValue={today.format(
                                                        "YYYY-MM-DD"
                                                      )}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Birthday
                                              </label>
                                              <div className="col-lg-9">
                                                <div className="input-group">
                                                  {/* <span
                                                      className="input-group-text"
                                                      id="basic-addon1"
                                                    >
                                                      <img src={Calendar} alt="img" />
                                                    </span> */}
                                                  <div
                                                    style={{ width: "100%" }}
                                                  >
                                                    <input
                                                      type="date"
                                                      className="form-control form-control-sm"
                                                      // value={birthday}
                                                      onChange={handleChange}
                                                      id="Birthday"
                                                      name="Birthday"
                                                      // dateFormat="MM-DD-YYYY"
                                                      // timeFormat={false}
                                                      // isValidDate={(currentDate) => {
                                                      //   const selectedDate =
                                                      //     moment(currentDate).startOf("day");
                                                      //   const today = moment().startOf("day");
                                                      //   return selectedDate <= today;
                                                      // }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Location{" "}
                                                {/* <span className="text-danger">
                                                  *
                                                </span> */}
                                              </label>
                                              <div className="col-lg-9">
                                                <Select
                                                  backspaceRemovesValue={false}
                                                  controlShouldRenderValue={
                                                    true
                                                  }
                                                  className="custom-search-select"
                                                  value={locationdropdown?.filter(
                                                    (obj) =>
                                                      selectedDefaultRegister?.includes(
                                                        obj.value
                                                      )
                                                  )}
                                                  isMulti={true}
                                                  hideSelectedOptions={true}
                                                  isClearable={true}
                                                  onChange={(event) =>
                                                    handleDefaultRegister(event)
                                                  }
                                                  options={locationdropdown}
                                                  placeholder="Select Warehouse"
                                                  styles={selectStyles}
                                                  // value={
                                                  //   selectedDefaultRegister
                                                  // }
                                                  id="DefaultRegister"
                                                  name="DefaultRegister"
                                                />

                                                {/* <div className="invalid-feedback">
                                                  {touched.DefaultRegister &&
                                                  errors.DefaultRegister
                                                    ? errors.DefaultRegister
                                                    : ""}
                                                </div> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 2 ? (
                                      <>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Address 1{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.Address1
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="Address1"
                                                  name="Address1"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.Address1 &&
                                                  errors.Address1
                                                    ? errors.Address1
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Country{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-10">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.Country
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="Country"
                                                  name="Country"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.Country &&
                                                  errors.Country
                                                    ? errors.Country
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                Address 2{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.Address2
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="Address2"
                                                  name="Address2"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.Address2 &&
                                                  errors.Address2
                                                    ? errors.Address2
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                City{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-10">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.City
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="City"
                                                  name="City"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.City && errors.City
                                                    ? errors.City
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-3 form-label">
                                                State/Province{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-9">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.StateProvince
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="StateProvince"
                                                  name="StateProvince"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.StateProvince &&
                                                  errors.StateProvince
                                                    ? errors.StateProvince
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Zip{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-lg-10">
                                                <Field
                                                  type="text"
                                                  className={`form-control form-control-sm ${
                                                    errors.Zip
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="Zip"
                                                  name="Zip"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.Zip && errors.Zip
                                                    ? errors.Zip
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 5 ? (
                                      <>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Comments
                                              </label>
                                              <div className="col-lg-10">
                                                <Field
                                                  as="textarea"
                                                  className={`form-control`}
                                                  onChange={handleChange}
                                                  id="Comments"
                                                  name="Comments"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="row">
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-2 form-label">
                                                  Allowed To Login Start Time
                                                </label>
                                                <div className="col-lg-10">
                                                  <div className="input-group">
                                                    <span
                                                      className="input-group-text"
                                                      id="basic-addon1"
                                                    >
                                                      <img src={Time} alt="img" />
                                                    </span>
                                                    <TimePicker
                                                      value={allowedToLoginStartTime}
                                                      onChange={onChangeAllowedToLoginStartTime}
                                                      showSecond={false}
                                                      style={{ width: "100%" }}
                                                      id="AllowedToLoginStartTime"
                                                      name="AllowedToLoginStartTime"
                                                      format="HH:mm"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-2 form-label">
                                                  Allowed To Login End Time
                                                </label>
                                                <div className="col-lg-10">
                                                  <div className="input-group">
                                                    <span
                                                      className="input-group-text"
                                                      id="basic-addon1"
                                                    >
                                                      <img src={Time} alt="img" />
                                                    </span>
                                                    <TimePicker
                                                      value={allowedToLoginEndTime}
                                                      onChange={onChangeAllowedToLoginEndTime}
                                                      showSecond={false}
                                                      style={{ width: "100%" }}
                                                      id="AllowedToLoginEndTime"
                                                      name="AllowedToLoginEndTime"
                                                      format="HH:mm"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-2 form-label">
                                                  Override Price Adjustments
                                                </label>
                                                <div className="col-md-10">
                                                  <div className="input-group">
                                                    <Field
                                                      className="form-check-input"
                                                      style={{ width: "1.5em", height: "1.5em" }}
                                                      type="checkbox"
                                                      id="OverridePriceAdjustments"
                                                      name="OverridePriceAdjustments"
                                                      onChange={handleChange}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-2 form-label">
                                                  Max Discount
                                                </label>
                                                <div className="col-lg-10">
                                                  <div className="input-group">
                                                    <Field
                                                      type="text"
                                                      className={`form-control form-control-sm ${errors.MaxDiscount ? "is-invalid" : ""
                                                        }`}
                                                      onChange={handleChange}
                                                      id="MaxDiscount"
                                                      name="MaxDiscount"
                                                    />
                                                    <span
                                                      className="input-group-text"
                                                      id="basic-addon1"
                                                    >
                                                      %
                                                    </span>
                                                    <div className="invalid-feedback">
                                                      {touched.MaxDiscount && errors.MaxDiscount
                                                        ? errors.MaxDiscount
                                                        : ""}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div> */}
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Commission Default Rate
                                              </label>
                                              <div className="col-lg-10">
                                                <div className="input-group">
                                                  <Field
                                                    type="text"
                                                    className={`form-control form-control-sm ${
                                                      errors.CommissionDefaultRate
                                                        ? "is-invalid"
                                                        : ""
                                                    }`}
                                                    onChange={handleChange}
                                                    id="CommissionDefaultRate"
                                                    name="CommissionDefaultRate"
                                                  />
                                                  <span
                                                    className="input-group-text"
                                                    id="basic-addon1"
                                                  >
                                                    %
                                                  </span>
                                                  <div className="invalid-feedback">
                                                    {touched.CommissionDefaultRate &&
                                                    errors.CommissionDefaultRate
                                                      ? errors.CommissionDefaultRate
                                                      : ""}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Commission Percent Calculation
                                                Method
                                              </label>
                                              <div className="col-lg-10">
                                                <Select
                                                  backspaceRemovesValue={false}
                                                  controlShouldRenderValue={
                                                    true
                                                  }
                                                  hideSelectedOptions={true}
                                                  isClearable={true}
                                                  onChange={
                                                    setSelectedCommissionPercentCalculationMethod
                                                  }
                                                  options={
                                                    commissionPercentCalculationMethod
                                                  }
                                                  placeholder=""
                                                  styles={selectStyles}
                                                  value={
                                                    selectedCommissionPercentCalculationMethod
                                                  }
                                                  id="CommissionPercentCalculationMethod"
                                                  name="CommissionPercentCalculationMethod"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-2 form-label">
                                                Language
                                              </label>
                                              <div className="col-lg-10">
                                                <Select
                                                  backspaceRemovesValue={false}
                                                  controlShouldRenderValue={
                                                    true
                                                  }
                                                  hideSelectedOptions={true}
                                                  isClearable={true}
                                                  onChange={
                                                    setSelectedLanguages
                                                  }
                                                  options={languages}
                                                  placeholder=""
                                                  styles={selectStyles}
                                                  value={selectedLanguages}
                                                  id="Language"
                                                  name="Language"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="row"> */}

                                        {/* <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-2 form-label">
                                                  Locations
                                                </label>
                                                <div className="col-sm-9 col-md-3 mr-2 pt-2 col-lg-10">
                                                  <div className="form-check mb-1">
                                                    {location.map((item) => {
                                                      console.log(selectedLocationItems);
                                                      console.log(item.Id.toString());
                                                      console.log(
                                                        selectedLocationItems?.indexOf(
                                                          item.Id.toString()
                                                        )
                                                      );
                                                      return (
                                                        <div key={item.Id}>
                                                          <input
                                                            className="form-check-input me-3"
                                                            style={{
                                                              width: "1.25em",
                                                              height: "1.25em",
                                                            }}
                                                            name="Locations"
                                                            type="checkbox"
                                                            defaultChecked={
                                                              selectedLocationItems?.indexOf(
                                                                item.Id.toString()
                                                              ) > -1
                                                                ? // selectedLocationItems?.includes(item.Id.toString())
                                                                true
                                                                : false
                                                            }
                                                            onChange={(event) => {
                                                              handleCheck(event);
                                                            }}
                                                            value={item.Id}
                                                          />
                                                          <label className={isCheck(item.Id)}>
                                                            {item.Name}
                                                          </label>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                        {/* </div> */}
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 4 ? (
                                      <>
                                        <div className="row">
                                          {customFields.map((data, index) => (
                                            <>
                                              <label
                                                className="col-form-label col-md-1 form-label mb-5"
                                                key={index}
                                              >
                                                {data.Name}
                                              </label>

                                              <div className="col-md-5">
                                                {data.TypeName === "Text" ? (
                                                  <Field
                                                    key={index}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "E-Mail" ? (
                                                  <Field
                                                    key={index}
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "Dropdown" ? (
                                                  <>
                                                    <Select
                                                      key={index}
                                                      id={data.TypeName}
                                                      name={data.Id}
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      onChange={(event) => {
                                                        handleCustomFieldsValues(
                                                          event,
                                                          data.TypeName,
                                                          data.Id
                                                        );
                                                        setSelectedCustomField(
                                                          event,
                                                          index
                                                        );
                                                      }}
                                                      options={data.Optionvalue.split(
                                                        ","
                                                      ).map((option) => ({
                                                        label: option,
                                                        value: option,
                                                        selected:
                                                          option ===
                                                          formValues[data.Id],
                                                      }))}
                                                      placeholder="Select"
                                                      styles={selectStyles}
                                                      defaultValue={
                                                        formValues[data.Id] !==
                                                          null &&
                                                        formValues[data.Id] !==
                                                          ""
                                                          ? {
                                                              label:
                                                                formValues[
                                                                  data.Id
                                                                ],
                                                              value:
                                                                formValues[
                                                                  data.Id
                                                                ],
                                                            }
                                                          : ""
                                                      }
                                                    />
                                                  </>
                                                ) : data.TypeName ===
                                                  "Checkbox" ? (
                                                  <Field
                                                    key={index}
                                                    className="form-check-input form-control form-control-sm"
                                                    style={{
                                                      width: "1.5em",
                                                      height: "1.5em",
                                                    }}
                                                    type="checkbox"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                      handleChange(event);
                                                    }}
                                                    onInput={
                                                      handleSelectCustomCheckBox
                                                    }
                                                  />
                                                ) : data.TypeName ===
                                                  "Website" ? (
                                                  <Field
                                                    key={index}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "PhoneNumber" ? (
                                                  <Field
                                                    key={index}
                                                    type="tel"
                                                    className="form-control form-control-sm"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : data.TypeName === "Date" ? (
                                                  <Field
                                                    key={index}
                                                    className="form-control form-control-sm"
                                                    type="date"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : data.TypeName ===
                                                  "Image" ? (
                                                  <>
                                                    <div className="row">
                                                      <FileInput
                                                        key={index}
                                                        className="form-control form-control-sm"
                                                        id={data.TypeName}
                                                        name={data.Id}
                                                        value={
                                                          selectedCustomImage
                                                        }
                                                        accept="image/*"
                                                        handleChange={(
                                                          event
                                                        ) => {
                                                          _handleFileChange(
                                                            event,
                                                            index
                                                          );
                                                          handleCustomFieldsValues(
                                                            event,
                                                            data.TypeName,
                                                            data.Name
                                                          );
                                                        }}
                                                      />
                                                    </div>

                                                    <img
                                                      src={`${
                                                        formValues[data.Id]
                                                          ? formValues[data.Id]
                                                          : selectedCustomImage
                                                      }`}
                                                      alt="Custom Image"
                                                      className="ImagePreviewSize mt-3 mb-3"
                                                    />
                                                  </>
                                                ) : data.TypeName === "File" ? (
                                                  <FileInput
                                                    key={index}
                                                    className="form-control form-control-sm"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    value={selectedCustomFile}
                                                    handleChange={(event) => {
                                                      _handleFileChange(
                                                        event,
                                                        index
                                                      );
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : null}
                                              </div>
                                            </>
                                          ))}
                                        </div>

                                        <div className="card">
                                          <div className="card-header">
                                            <h5 className="card-title">
                                              Files
                                            </h5>
                                          </div>
                                          <div className="card-body">
                                            <div className="row">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-2 form-label">
                                                    File 1
                                                  </label>
                                                  <div className="col-md-10">
                                                    <Field
                                                      type="hidden"
                                                      name="FileId1"
                                                    />
                                                    <FileInput
                                                      className="form-control form-control-sm"
                                                      id="File1"
                                                      name="File1"
                                                      value={selectedFile1}
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-2 form-label">
                                                    File 2
                                                  </label>
                                                  <div className="col-md-10">
                                                    <Field
                                                      type="hidden"
                                                      name="FileId2"
                                                    />
                                                    <FileInput
                                                      className="form-control form-control-sm"
                                                      id="File2"
                                                      name="File2"
                                                      value={selectedFile2}
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-2 form-label">
                                                    File 3
                                                  </label>
                                                  <div className="col-md-10">
                                                    <Field
                                                      type="hidden"
                                                      name="FileId3"
                                                    />
                                                    <FileInput
                                                      className="form-control form-control-sm"
                                                      id="File3"
                                                      name="File3"
                                                      value={selectedFile3}
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-2 form-label">
                                                    File 4
                                                  </label>
                                                  <div className="col-md-10">
                                                    <Field
                                                      type="hidden"
                                                      name="FileId4"
                                                    />
                                                    <FileInput
                                                      className="form-control form-control-sm"
                                                      id="File4"
                                                      name="File4"
                                                      value={selectedFile4}
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-sm-6">
                                                <div className="row">
                                                  <label className="col-form-label col-md-2 form-label">
                                                    File 5
                                                  </label>
                                                  <div className="col-md-10">
                                                    <Field
                                                      type="hidden"
                                                      name="FileId5"
                                                    />
                                                    <FileInput
                                                      className="form-control form-control-sm"
                                                      id="File5"
                                                      name="File5"
                                                      value={selectedFile5}
                                                      handleChange={
                                                        _handleFileChange
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 7 ? (
                                      <>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                Message To Show When Adding
                                                Customer To Sale
                                              </label>
                                              <div className="col-md-8">
                                                <Field
                                                  as="textarea"
                                                  className="form-control form-control-sm"
                                                  onChange={handleChange}
                                                  id="MessageToShowWhenAddingCustomerToSale"
                                                  name="MessageToShowWhenAddingCustomerToSale"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                Auto Email Receipt
                                              </label>
                                              <div className="col-md-8">
                                                <Field
                                                  className="form-check-input"
                                                  style={{
                                                    width: "1.5em",
                                                    height: "1.5em",
                                                  }}
                                                  type="checkbox"
                                                  id="AutoEmailReceipt"
                                                  name="AutoEmailReceipt"
                                                  onChange={handleChange}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                REP
                                              </label>
                                              <div className="col-md-8">
                                                <Field
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  onChange={handleChange}
                                                  id="REP"
                                                  name="REP"
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                Alternate Phone
                                              </label>
                                              <div className="col-md-8">
                                                <Field
                                                  type="number"
                                                  className={`form-control form-control-sm ${
                                                    errors.AlternatePhone
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                  id="AlternatePhone"
                                                  name="AlternatePhone"
                                                  maxLength="10"
                                                />
                                                <div className="invalid-feedback">
                                                  {touched.AlternatePhone &&
                                                  errors.AlternatePhone
                                                    ? errors.AlternatePhone
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="row">
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-4 form-label">
                                                  Tax ID
                                                </label>
                                                <div className="col-md-8">
                                                  <Field
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={handleChange}
                                                    id="TaxID"
                                                    name="TaxID"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-4 form-label">
                                                  Electronic Cigarette Id
                                                </label>
                                                <div className="col-md-8">
                                                  <Field
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={handleChange}
                                                    id="ElectronicCigaretteId"
                                                    name="ElectronicCigaretteId"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div> */}
                                        <div className="row">
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                Instagram
                                              </label>
                                              <div className="col-md-8">
                                                <Field
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  onChange={handleChange}
                                                  id="Instagram"
                                                  name="Instagram"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          {/* <div className="col-sm-6">
                                              <div className="row">
                                                <label className="col-form-label col-md-4 form-label">
                                                  Tobacco License
                                                </label>
                                                <div className="col-md-8">
                                                  <Field
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={handleChange}
                                                    id="TobaccoLicense"
                                                    name="TobaccoLicense"
                                                  />
                                                </div>
                                              </div>
                                            </div> */}
                                          {/* </div>
                                          <div className="row"> */}
                                          <div className="col-sm-6">
                                            <div className="row">
                                              <label className="col-form-label col-md-4 form-label">
                                                ROUTE
                                              </label>
                                              <div className="col-md-8">
                                                <Select
                                                  backspaceRemovesValue={false}
                                                  controlShouldRenderValue={
                                                    true
                                                  }
                                                  hideSelectedOptions={true}
                                                  isClearable={true}
                                                  // onChange={setSelectedRoute}
                                                  // options={route}
                                                  // placeholder=""
                                                  // styles={selectStyles}
                                                  // value={selectedRoute}
                                                  id="Route"
                                                  name="Route"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 5 ? (
                                      <>
                                        <div className="row">
                                          {customFields.map((data, index) => (
                                            <>
                                              <label
                                                className="col-form-label col-md-2 form-label mb-5"
                                                key={index}
                                              >
                                                {data.Name}
                                              </label>

                                              <div className="col-md-4">
                                                {data.TypeName === "Text" ? (
                                                  <Field
                                                    key={index}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "Email" ? (
                                                  <Field
                                                    key={index}
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "Dropdown" ? (
                                                  <>
                                                    <Select
                                                      key={index}
                                                      id={data.TypeName}
                                                      name={data.Id}
                                                      backspaceRemovesValue={
                                                        false
                                                      }
                                                      controlShouldRenderValue={
                                                        true
                                                      }
                                                      hideSelectedOptions={true}
                                                      isClearable={true}
                                                      onChange={(event) => {
                                                        handleCustomFieldsValues(
                                                          event,
                                                          data.TypeName,
                                                          data.Id
                                                        );
                                                        setSelectedCustomField(
                                                          event,
                                                          index
                                                        );
                                                      }}
                                                      options={data.Optionvalue.split(
                                                        ","
                                                      ).map((option) => ({
                                                        label: option,
                                                        value: option,
                                                        selected:
                                                          option ===
                                                          formValues[data.Id],
                                                      }))}
                                                      placeholder="Select"
                                                      styles={selectStyles}
                                                      defaultValue={
                                                        formValues[data.Id] !==
                                                          null &&
                                                        formValues[data.Id] !==
                                                          ""
                                                          ? {
                                                              label:
                                                                formValues[
                                                                  data.Id
                                                                ],
                                                              value:
                                                                formValues[
                                                                  data.Id
                                                                ],
                                                            }
                                                          : ""
                                                      }
                                                    />
                                                  </>
                                                ) : data.TypeName ===
                                                  "Checkbox" ? (
                                                  <Field
                                                    key={index}
                                                    className="form-check-input form-control form-control-sm"
                                                    style={{
                                                      width: "1.5em",
                                                      height: "1.5em",
                                                    }}
                                                    type="checkbox"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                      handleChange(event);
                                                    }}
                                                    onInput={
                                                      handleSelectCustomCheckBox
                                                    }
                                                  />
                                                ) : data.TypeName ===
                                                  "Website" ? (
                                                  <Field
                                                    key={index}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                  />
                                                ) : data.TypeName ===
                                                  "PhoneNumber" ? (
                                                  <Field
                                                    key={index}
                                                    type="tel"
                                                    className="form-control form-control-sm"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : data.TypeName === "Date" ? (
                                                  <Field
                                                    key={index}
                                                    className="form-control form-control-sm"
                                                    type="date"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    onChange={(event) => {
                                                      handleChange(event);
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : data.TypeName ===
                                                  "Image" ? (
                                                  <>
                                                    <div className="row">
                                                      <FileInput
                                                        key={index}
                                                        className="form-control form-control-sm"
                                                        id={data.TypeName}
                                                        name={data.Id}
                                                        value={
                                                          selectedCustomImage
                                                        }
                                                        accept="image/*"
                                                        handleChange={(
                                                          event
                                                        ) => {
                                                          _handleFileChange(
                                                            event,
                                                            index
                                                          );
                                                          handleCustomFieldsValues(
                                                            event,
                                                            data.TypeName,
                                                            data.Name
                                                          );
                                                        }}
                                                      />
                                                    </div>

                                                    <div className="row">
                                                      <div className="mt-2">
                                                        <div
                                                          className={`${
                                                            formValues[data.Id]
                                                              ? ""
                                                              : selectedCustomImage
                                                              ? ""
                                                              : "d-none"
                                                          } row`}
                                                        >
                                                          <label className="col-form-label col-md-2 form-label"></label>
                                                          <div>
                                                            <img
                                                              src={`${
                                                                formValues[
                                                                  data.Id
                                                                ]
                                                                  ? formValues[
                                                                      data.Id
                                                                    ]
                                                                  : selectedCustomImage
                                                              }`}
                                                              alt="Category Image"
                                                              className="ImagePreviewSize"
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : data.TypeName === "File" ? (
                                                  <FileInput
                                                    key={index}
                                                    className="form-control form-control-sm"
                                                    id={data.TypeName}
                                                    name={data.Id}
                                                    value={selectedCustomFile}
                                                    handleChange={(event) => {
                                                      _handleFileChange(
                                                        event,
                                                        index
                                                      );
                                                      handleCustomFieldsValues(
                                                        event,
                                                        data.TypeName,
                                                        data.Name
                                                      );
                                                    }}
                                                  />
                                                ) : null}
                                              </div>
                                            </>
                                          ))}
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {managecustomerID === 3 ? (
                                      <>
                                        <div className="card">
                                          <div className="card-header">
                                            <h5 className="card-title">
                                              Employee Login Info
                                            </h5>
                                          </div>
                                          {paramObject.id == undefined ? (
                                            <div className="card-body">
                                              <div className="row">
                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-3 form-label">
                                                      Username{" "}
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    </label>
                                                    <div className="col-md-9">
                                                      <Field
                                                        type="text"
                                                        className={`form-control form-control-sm ${
                                                          errors.Username
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="Username"
                                                        name="Username"
                                                        disabled={
                                                          paramObject.id > 0
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.Username &&
                                                        errors.Username
                                                          ? errors.Username
                                                          : ""}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Password
                                                    </label>
                                                    <div className="pass-group col-md-9">
                                                      {/* <div className="input-group"> */}
                                                      <Field
                                                        type={
                                                          eyeNew
                                                            ? "password"
                                                            : "text"
                                                        }
                                                        className={`form-control form-control-sm ${
                                                          errors.Password
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="Password"
                                                        name="Password"
                                                      />
                                                      <span
                                                        onClick={onEyeNewClick}
                                                        className={`fas toggle-password ${
                                                          eyeNew
                                                            ? "fa-eye-slash"
                                                            : "fa-eye"
                                                        } `}
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.Password &&
                                                        errors.Password
                                                          ? errors.Password
                                                          : ""}
                                                      </div>
                                                      {/* </div> */}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-3 form-label">
                                                      Password Again
                                                    </label>
                                                    <div className="pass-group col-md-9">
                                                      <Field
                                                        type={
                                                          eyepasswordnew
                                                            ? "password"
                                                            : "text"
                                                        }
                                                        className={`form-control form-control-sm ${
                                                          errors.PasswordAgain
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="PasswordAgain"
                                                        name="PasswordAgain"
                                                      />
                                                      <span
                                                        onClick={
                                                          onEyePasswordNewClick
                                                        }
                                                        className={`fas toggle-password ${
                                                          eyepasswordnew
                                                            ? "fa-eye-slash"
                                                            : "fa-eye"
                                                        } `}
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.PasswordAgain &&
                                                        errors.PasswordAgain
                                                          ? errors.PasswordAgain
                                                          : ""}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Inactive
                                                    </label>
                                                    <div className="col-lg-10">
                                                      <div className="input-group">
                                                        <Field
                                                          className="form-check-input"
                                                          style={{
                                                            width: "1.5em",
                                                            height: "1.5em",
                                                          }}
                                                          type="checkbox"
                                                          id="Inactive"
                                                          name="Inactive"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          onInput={
                                                            handleSelectInactive
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="row">
                                                <div
                                                  className={`${
                                                    selectInactive === true
                                                      ? "col-sm-6"
                                                      : "d-none"
                                                  }`}
                                                >
                                                  <div className="row">
                                                    <label className="col-form-label col-md-3 form-label">
                                                      Reason Inactive
                                                    </label>
                                                    <div className="col-md-9">
                                                      <div className="input-group">
                                                        <Field
                                                          as="textarea"
                                                          className={`form-control form-control-sm`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="ReasonInactive"
                                                          name="ReasonInactive"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="card-body">
                                              <div className="row">
                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-3 form-label">
                                                      Username{" "}
                                                      <span className="text-danger">
                                                        *
                                                      </span>
                                                    </label>
                                                    <div className="col-md-9">
                                                      <Field
                                                        type="text"
                                                        className={`form-control form-control-sm ${
                                                          errors.Username
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        onChange={handleChange}
                                                        id="Username"
                                                        name="Username"
                                                        disabled={
                                                          paramObject.id > 0
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      <div className="invalid-feedback">
                                                        {touched.Username &&
                                                        errors.Username
                                                          ? errors.Username
                                                          : ""}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="col-sm-6">
                                                  <div className="row">
                                                    <label className="col-form-label col-md-2 form-label">
                                                      Inactive
                                                    </label>
                                                    <div className="col-lg-10">
                                                      <div className="input-group">
                                                        <Field
                                                          className="form-check-input"
                                                          style={{
                                                            width: "1.5em",
                                                            height: "1.5em",
                                                          }}
                                                          type="checkbox"
                                                          id="Inactive"
                                                          name="Inactive"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          onInput={
                                                            handleSelectInactive
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="row">
                                                <div
                                                  className={`${
                                                    selectInactive === true
                                                      ? "col-sm-6"
                                                      : "d-none"
                                                  }`}
                                                >
                                                  <div className="row">
                                                    <label className="col-form-label col-md-3 form-label">
                                                      Reason Inactive
                                                    </label>
                                                    <div className="col-md-9">
                                                      <div className="input-group">
                                                        <Field
                                                          as="textarea"
                                                          className={`form-control form-control-sm`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          id="ReasonInactive"
                                                          name="ReasonInactive"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <div>
                                      <div className="pull-right ">
                                        <button
                                          type="submit"
                                          className="btn btn-sm  btn-primary pull-right mb-3"
                                          onClick={() => {
                                            validateForm().then((errors) => {
                                              console.log("Errors:--", errors);

                                              if (
                                                Object.keys(errors).length === 0
                                              ) {
                                                console.log("Form is valid");

                                                return true;
                                              } else {
                                                console.log("Form is invalid");

                                                toastError(
                                                  "Please Fill" +
                                                    " " +
                                                    `${
                                                      errors.Username
                                                        ? " " + "EmployeeLogin"
                                                        : ""
                                                    }` +
                                                    `${
                                                      errors.FirstName ||
                                                      errors.LastName ||
                                                      errors.EMail ||
                                                      errors.PhoneNumber
                                                        ? " " +
                                                          " " +
                                                          "PersonalDetails"
                                                        : ""
                                                    }` +
                                                    `${
                                                      errors.Address1 ||
                                                      errors.Address2 ||
                                                      errors.City ||
                                                      errors.StateProvince ||
                                                      errors.Zip ||
                                                      errors.Country
                                                        ? " " + " " + "Address"
                                                        : ""
                                                    }`
                                                );

                                                return false;
                                              }
                                            });
                                          }}
                                        >
                                          Save
                                        </button>
                                        <div
                                          onClick={() => navigate("/employees")}
                                          className="btn btn-sm btn-dark btn-md me-1 pull-right"
                                        >
                                          Cancel
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* </ConditionalComponent> */}
                                </Form>
                              </>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageEmployee;
